import { Navigate, RouteObject } from "react-router";
import LazyRouter from "@/components/LazyRouter";

/**基础路由 */
const base_routers: RouteObject[] = [
    {
        element: <LazyRouter load={() => import("@/pages/layout")} />,
        children: [
            {
                path: "dashboard",
                element: <LazyRouter load={() => import("@/pages/dashboard")} />,
            },
            { path: "*", element: <LazyRouter load={() => import("@/pages/404")} /> },
        ]
    },
    { path: "login", element: <LazyRouter load={() => import("@/pages/login")} /> },
    { path: "autoLogin", element: <LazyRouter load={() => import("@/pages/autoLogin")} /> },
    { path: "tyrz", element: <LazyRouter load={() => import("@/pages/tyrz")} /> },
    { path: "*", element: <Navigate to={"/dashboard"} /> },
];

export default base_routers;